import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2190975c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-snippet d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "mx-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "lni lni-clipboard" })
], -1))
const _hoisted_4 = { class: "code-snippet" }

import { ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CodeSnippet',
  props: {
    code: {},
    lang: {}
  },
  setup(__props: any) {

  

  const codeElement = ref<HTMLElement | null>(null)

  const copyCode = () => {
    const code = codeElement.value?.textContent
    if (code) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          alert('Code copied to clipboard!')
        })
        .catch((error) => {
          console.error('Failed to copy code:', error)
        })
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.lang), 1),
      _createElementVNode("button", {
        class: "copy-button mx-3",
        onClick: copyCode
      }, [
        _hoisted_3,
        _createTextVNode(" Copy Code ")
      ])
    ]),
    _createElementVNode("pre", _hoisted_4, [
      _createTextVNode("      "),
      _createElementVNode("code", {
        ref_key: "codeElement",
        ref: codeElement,
        class: "d-flex text-start fs-5 px-4 px-sm-5"
      }, "\n        " + _toDisplayString(_ctx.code) + "\n      ", 513),
      _createTextVNode("\n    ")
    ])
  ], 64))
}
}

})